import React, { useContext } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Td,
  Th,
  Box,
  Flex,
  useToast,
} from "@chakra-ui/react";
import { ProductsContext } from "../../Context/ProductsContext";
import useFetch from "../../../hooks/useFetch";
import CustomTBody from "../../Common/Table/CustomTBody";
import { createSkeleton } from "../../../Utils/utils";
import Pagination from "../../Common/Layout/Pagination";
import ProductItem from "./ProductItem";

function ProductsTable({
  priceListProducts,
  purchaseId,
  setProducts,
  setIsEdited,
}) {
  const {
    products,
    isLoadingProduct,
    maxPagination,
    currentPage,
    setPagination,
  } = useContext(ProductsContext);
  const toast = useToast();
  const { put } = useFetch();

  const handleSwitch = (product, e) => {
    const value = e.target.checked;
    const name = e.target.id;
    let newProducts = [...products];

    let index = newProducts.findIndex(
      (newProduct) => product.id === newProduct.id
    );
    newProducts[index][name] = value;
    setProducts(newProducts);

    const formData = new FormData();
    formData.append(name, value ? 1 : 0);

    put(`/products/${product.id}`, formData)
      .then(async () => {
        toast({
          title: "Articulo editado con éxito.",
          description: "Se ha actualizado el artículo.",
          status: "success",
          duration: 4000,
          isClosable: true,
        });
      })
      .catch((e) => {
        toast({
          title: "Se ha producido un error.",
          description:
            e?.message || "Contacte con el administrador del sistema.",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
      });
  };

  const handleSelectedPage = (page) => {
    setPagination(page);
  };

  const updateProduct = (newProduct) => {
    let newProducts = [...priceListProducts];
    let index = newProducts.findIndex((p) => p.id == newProduct.id);

    console.log(index);

    if (index === -1) {
      newProducts = [newProduct, ...newProducts];
    } else {
      newProducts[index] = newProduct;
    }

    setProducts(newProducts);
  };

  return (
    <>
      <Box overflowX={"scroll"} pb={"0.5rem"}>
        <Table variant="striped" colorScheme="gray" fontSize="0.8em">
          <Thead>
            <Tr>
              <Th fontSize="0.8em">Artículo</Th>
              <Th fontSize="0.8em">Costo ($)</Th>
              <Th fontSize="0.8em">Gan. (%)</Th>
              <Th fontSize="0.8em">Precio con gan. ($)</Th>
              <Th fontSize="0.8em">Desc. (%)</Th>
              <Th fontSize="0.8em">Precio con desc. ($)</Th>
              <Th fontSize="0.8em">Activo</Th>
              <Th fontSize="0.8em" textAlign="center">
                Acciones
              </Th>
            </Tr>
          </Thead>
          {isLoadingProduct ? (
            <CustomTBody rows={[createSkeleton(8)]} />
          ) : products.length ? (
            products.map((product) => (
              <ProductItem
                key={product.id}
                product={product}
                updateProduct={updateProduct}
                priceListProducts={priceListProducts}
                products={products}
                setIsEdited={setIsEdited}
              />
            ))
          ) : (
            <Tbody>
              <Tr>
                <Td colSpan="100%">
                  <Box padding="1rem 0">No se encontraron resultados</Box>
                </Td>
              </Tr>
            </Tbody>
          )}
        </Table>
      </Box>
      <Flex justifyContent={"center"} py={"2rem"}>
        <Pagination
          max={maxPagination}
          currentPage={currentPage}
          handleSelectedPage={handleSelectedPage}
        />
      </Flex>
    </>
  );
}

export default ProductsTable;
